import { Grid, Typography } from '@mui/material';
import { IRoomBlocking } from '../../../interfaces/IPartnerPms';
import { useCallback, useMemo } from 'react';
import Dialog, { IDefaultDialogProps } from '../../Dialog';
import { ActionButton } from '../../Button';
import { useLanguageContext } from '../../../contexts/LanguageContext';
import DefaultConstants from '../../../data/Constants';
import FormHelper from '../../../helpers/FormHelper';
import PartnerPmsService from '../../../services/PartnerPmsService';
import DateTimeHelper from '../../../helpers/DateTimeHelper';
import { Warning } from '@mui/icons-material';


interface IRemoveRoomBlockingConfirmationDialogProps extends IDefaultDialogProps {
    roomBlocking: IRoomBlocking;
    handleSubmitCallback: () => void;
}


const RemoveRoomBlockingConfirmationDialog: React.FC<IRemoveRoomBlockingConfirmationDialogProps> = ({
    open,
    handleClose,
    roomBlocking,
    handleSubmitCallback,
}) => {
    const { translate } = useLanguageContext();


    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (roomBlocking === undefined) {
            return;
        }

        let formData = FormHelper.Create(event);
        formData = FormHelper.Add(formData, 'id', roomBlocking.id);

        PartnerPmsService.RemoveRoomBlocking(formData).then(() => {
            handleClose();
            handleSubmitCallback();
        });

        // eslint-disable-next-line
    }, [roomBlocking]);


    const dialogActions = useMemo(() => {
        return [
            <ActionButton action='no' onClick={handleClose} />,
            <ActionButton action='yes' type='submit' />
        ];
        // eslint-disable-next-line
    }, [translate]);
    

    return (
        <>
            <Dialog
                open={open}
                handleClose={handleClose}
                title={translate('removeBlocking')}
                onSubmit={handleSubmit}
                dialogActions={dialogActions}
                className='dialogactions-spacebetween overflow-inherit'
                absolute={true}
                dividers={true}
            >
                <Grid container rowSpacing={DefaultConstants.gridRowSpacing} columnSpacing={DefaultConstants.gridColumnSpacing}>
                    <Grid item xs={12}>
                        <Typography variant='body1'>
                            {
                                translate('_governanceDialogRemoveRoomBlockingDescription')
                                    .replace('{date}', DateTimeHelper.Format(roomBlocking.date, 'DD/MM/YYYY') ?? '-')
                            }
                        </Typography>
                    </Grid>

                    <Grid item xs={12} marginTop={1} className='color-red'>
                        <Typography variant='body1' className='fontsize-14 fontweight-600 display-flex gap-6 alignitems-center'>
                            <Warning className='fontsize-14' />
                            {translate('attention')}:
                        </Typography>

                        <Typography variant='body1'>
                            {translate('_governanceDialogRemoveRoomBlockingAlertDescription')}
                        </Typography>
                    </Grid>
                </Grid>
            </Dialog>
        </>
    );
}

export default RemoveRoomBlockingConfirmationDialog;